import ManageCostCode from './Containers/manage-cost-code';
import {AppSettings} from '../constants';

export default [
  {
    path: '/cost-code',
    component: ManageCostCode,
    private: true,
    portal: ['Builder'],
    menu: {
      name: 'Cost codes',
      group: 'Admin',
      icons: 'icon-cost-codes-ic',
      order: 1,
      subGroup: 'Other',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/CostCodes/routers.js